import React from 'react';

import { ValidateTemplate } from '@hero/templates';

import AuthLayout from '../layout';

export default function ValidatePage() {
  return (
    <AuthLayout>
      <ValidateTemplate />
    </AuthLayout>
  );
}
